var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[(_vm.isBack)?_c('i',{class:['iconfont','icon-left'],on:{"click":_vm.goBack}}):_c('i'),_vm._t("default",[_c('h2',[_vm._v("最近来访")])]),_c('span')],2)}
var staticRenderFns = []

export { render, staticRenderFns }